import { APP_INITIALIZER, NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { NgSelectModule } from '@ng-select/ng-select';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';
import { DashboardComponent } from './components/dashboard/dashboard.component';
// import { MySocketWrapper } from './services/socket-service/socket-wrapper';
// import { SocketService } from './services/socket-service/socket-service.service';
import { DatePipe } from './pipes/date-pipe/date.pipe';
import { SideNavComponent } from './components/shared/layout/side-nav/side-nav.component';
import { HeaderComponent } from './components/shared/layout/header/header.component';
import { OWL_DATE_TIME_FORMATS, OwlDateTimeModule, OwlNativeDateTimeModule } from '@danielmoncada/angular-datetime-picker';
import { ToastrModule } from 'ngx-toastr';
import { NgMultiSelectDropDownModule } from 'ng-multiselect-dropdown';
import { SigninComponent } from './components/auth/signin/signin.component';
import { ResetPasswordComponent } from './components/auth/reset-password/reset-password.component';
import { TokenInterceptor } from './services/app/token-interceptor/token.interceptor';
import { SortByPipe } from './pipes/order-by/order-by.pipe';
import { CamelCasePipe } from './pipes/camelcase.filter/camelcase.filter.pipe';
import { GoogleMapsModule } from '@angular/google-maps';
import { NgxUiLoaderConfig, NgxUiLoaderHttpModule, NgxUiLoaderModule } from 'ngx-ui-loader';
import { ClockTimePipe } from './pipes/clock-time/clock-time.pipe';
import { FilterPipe } from './pipes/list-filter-pipe/list-filter-pipe';
import { CircleTimerModule } from "./libraries/circle-timer/src/lib/circle-timer.module";
import { MySocketWrapper } from './services/app/socket-service/socket-wrapper';
import { SocketService } from './services/app/socket-service/socket-service.service';
import { CredentialListComponent } from './components/credentials/credentials-company/credential-list/credential-list.component';
import { CommonModule } from '@angular/common';
import { CompanyComponent } from './components/credentials/company/company.component';
import { DriverComponent } from './components/credentials/drivers/driver/driver.component';
import { NgxPaginationModule } from 'ngx-pagination';
import { GooglePlaceDirective } from './directives/google-places-directive/google-place.directive';
import { SignupDetailsSlideoutComponent } from './components/slideouts/signup-details/signup-details-slideout.component';
import { VehiclesComponent } from './components/credentials/vehicle/vehicles/vehicles.component';
import { DriverVerificationSlideoutComponent } from './components/slideouts/driver-verification/driver-verification-slideout.component';
import { AddDriverComponent } from './components/credentials/drivers/add-driver/add-driver.component';
import { AddVehicleComponent } from './components/credentials/vehicle/add-vehicle/add-vehicle.component';
import { AddCredentialCompanyComponent } from './components/credentials/credentials-company/add-credential-company/add-credential-company.component';
import { VehicleVerificationComponent } from './components/slideouts/vehicle-verification/vehicle-verification.component';
import { ProfileComponent } from './components/profile/profile.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TripListComponent } from './components/distributions/trip-list/trip-list.component';
import { TripDetailModalComponent } from './components/slideouts/trip-detail-modal/trip-detail-modal.component';
import { MarketplaceComponent } from './components/marketplace/marketplace/marketplace.component';
import { TripActionDropdownComponent } from './components/dropdowns/trip-action-dropdown/trip-action-dropdown.component';
import { OutsideClickDirective } from './directives/outside-click-directive/outside-click.directive';
import { OWL_MOMENT_DATE_TIME_ADAPTER_OPTIONS, OwlMomentDateTimeModule } from '@danielmoncada/angular-datetime-picker-moment-adapter';
import { GoogleMapsInitializer } from './services/app/googlemap-key-service/google-maps-initializer.service';
import { NotificationsComponent } from './components/shared/layout/notifications/notifications.component';
import { ConvertPhoneNumberDirective } from './directives/number-directive/convert-phone-number.directive';
import { ConfigurationComponent } from './components/configuration/configuration/configuration.component';
import { ListGpsComponent } from './components/list-gps/list-gps.component';
import { ListEventComponent } from './components/list-event/list-event.component';
import { AdjustmentFormComponent } from './components/billing/adjustment-form/adjustment-form.component';
import { BillingListComponent } from './components/billing/billing-list/billing-list.component';
import { NotesModalComponent } from './components/slideouts/notes-modal/notes-modal.component';
import { MemberWrapperComponent } from './components/slideouts/member-wrapper/member-wrapper.component';
import { AddressPickerModalComponent } from './components/slideouts/address-picker-modal/address-picker-modal.component';
import { AddMemberComponent } from './components/slideouts/add-member/add-member.component';
import { TripTrailsModalComponent } from './components/slideouts/trip-trails-modal/trip-trails-modal.component';
import { DobFormatterPipe } from './pipes/dob-formatter/dob-formatter.pipe';
import { MultiCancelModalComponent } from './components/slideouts/multi-cancel-modal/multi-cancel-modal.component';
import { ReportConfigurationModalComponent } from './components/slideouts/report-configuration-modal/report-configuration-modal.component';
import { NotificationModalComponent } from './components/slideouts/notification-modal/notification-modal.component';
import { BulkManualPaymentModalComponent } from './components/slideouts/bulk-manual-payment-modal/bulk-manual-payment-modal.component';
import { TripSignatureModalComponent } from './components/slideouts/trip-signature-modal/trip-signature-modal.component';
import { DriverEditModalComponent } from './components/slideouts/driver-edit-modal/driver-edit-modal.component';
import { ForgotPasswordComponent } from './components/auth/forgot-password/forgot-password/forgot-password.component';
import { ToolTipDirective } from './directives/tooltip-directive/tool-tip.directive';
import { CopyToClipboardDirective } from './directives/clipboard-directive/copy-to-clipboard.directive';
import { TutorialsListComponent } from './components/tutorials/tutorials-list/tutorials-list.component';
import { StatisticsComponent } from './components/statistics/statistics.component';
import { SupportTicketsComponent } from './components/support/support-tickets/support-tickets.component';
import { SupportChatComponent } from './components/support/support-chat/support-chat.component';
import { ChatThreadComponent } from './components/support/chat-thread/chat-thread.component';
import { TicketDetailComponent } from './components/support/ticket-detail/ticket-detail.component';
import { AddSupportTicketComponent } from './components/support/add-support-ticket/add-support-ticket.component';
import { SupportContactPickerComponent } from './components/support/support-contact-picker/support-contact-picker.component';
import { SupportReferenceDetailComponent } from './components/support/support-reference-detail/support-reference-detail.component';



export const MY_MOMENT_FORMATS = {
  fullPickerInput: 'MM/DD/YYYY HHmm',
  parseInput: 'l LT',
  datePickerInput: 'l',
  timePickerInput: 'HH:mm',
  monthYearLabel: 'MMM YYYY',
  dateA11yLabel: 'LL',
  monthYearA11yLabel: 'MMMM YYYY',
};

const ngxUiLoaderConfig: NgxUiLoaderConfig = {
  bgsColor: 'red',
  bgsOpacity: 0.5,
  bgsPosition: 'bottom-right',
  bgsSize: 80,
  bgsType: 'ball-spin-clockwise',
  blur: 0,
  fgsColor: '#727cf5',
  fgsPosition: 'center-center',
  fgsSize: 0,
  fgsType: 'ball-spin',
  gap: 24,
  logoPosition: 'center-center',
  logoSize: 150,
  logoUrl: '',
  masterLoaderId: 'master',
  overlayBorderRadius: '0',
  overlayColor: '#ffffff00',
  pbColor: '#727cf5',
  pbDirection: 'ltr',
  pbThickness: 3,
  hasProgressBar: true,
  text: '',
  textColor: '#FFFFFF',
  textPosition: 'center-center',
};

@NgModule({
  declarations: [
    AppComponent,
    DashboardComponent,
    SideNavComponent,
    HeaderComponent,
    SigninComponent,
    ResetPasswordComponent,
    SortByPipe,
    CamelCasePipe,
    ClockTimePipe,
    FilterPipe,
    DatePipe,
    CredentialListComponent,
    CompanyComponent,
    DriverComponent,
    GooglePlaceDirective,
    SignupDetailsSlideoutComponent,
    VehiclesComponent,
    DriverVerificationSlideoutComponent,
    AddDriverComponent,
    AddVehicleComponent,
    AddCredentialCompanyComponent,
    VehicleVerificationComponent,
    ProfileComponent,
    TripListComponent,
    TripDetailModalComponent,
    MarketplaceComponent,
    TripActionDropdownComponent,
    OutsideClickDirective,
    NotificationsComponent,
    ConvertPhoneNumberDirective,
    ConfigurationComponent,
    ListGpsComponent,
    ListEventComponent,
    AdjustmentFormComponent,
    BillingListComponent,
    NotesModalComponent,
    MemberWrapperComponent,
    AddressPickerModalComponent,
    AddMemberComponent,
    TripTrailsModalComponent,
    DobFormatterPipe,
    MultiCancelModalComponent,
    ReportConfigurationModalComponent,
    NotificationModalComponent,
    TripSignatureModalComponent,
    BulkManualPaymentModalComponent,
    DriverEditModalComponent,
    ForgotPasswordComponent,
    ToolTipDirective,
    CopyToClipboardDirective,
    TutorialsListComponent,
    StatisticsComponent,
    SupportTicketsComponent,
    SupportChatComponent,
    ChatThreadComponent,
    TicketDetailComponent,
    AddSupportTicketComponent,
    SupportContactPickerComponent,
    SupportReferenceDetailComponent,
  ],
  imports: [
    BrowserModule,
    FormsModule,
    NgSelectModule,
    ReactiveFormsModule,
    BrowserAnimationsModule,
    AppRoutingModule,
    HttpClientModule,
    NgxPaginationModule,
    NgxUiLoaderModule.forRoot(ngxUiLoaderConfig), // import NgxUiLoaderModule
    NgxUiLoaderHttpModule.forRoot({
      exclude: [
      ],
      excludeRegexp: [
        'notifications/unread-count',
        // support chat requests run in the background while the user is chatting
        'support/chats/'
      ],
      showForeground: true
    }),
    OwlDateTimeModule,
    OwlMomentDateTimeModule,
    ToastrModule.forRoot({
      timeOut: 2000,
      maxOpened: 6,
      autoDismiss: true,
      positionClass: 'toast-bottom-left',
      // preventDuplicates: true,
      progressBar: true
    }),
    NgMultiSelectDropDownModule.forRoot(),
    GoogleMapsModule,
    NgSelectModule,
    CircleTimerModule,
    CommonModule,

],
  // providers: [
  //   { provide: UnAuthorizationGuard, useClass: UnAuthorizationGuard },
  // ],
  providers: [
      {
      provide: APP_INITIALIZER,
      useFactory: (initializer: GoogleMapsInitializer) => () => initializer.initialize(),
      deps: [GoogleMapsInitializer],
      multi: true
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: TokenInterceptor,
      multi: true
    },
    // { provide: AuthorizationGuard, useClass: AuthorizationGuard },
    // { provide: UnAuthorizationGuard, useClass: UnAuthorizationGuard },
    { provide: OWL_DATE_TIME_FORMATS, useValue: MY_MOMENT_FORMATS },
    { provide: OWL_MOMENT_DATE_TIME_ADAPTER_OPTIONS, useValue: { useUtc: false } },
    // {
    //   provide: PERFECT_SCROLLBAR_CONFIG,
    //   useValue: DEFAULT_PERFECT_SCROLLBAR_CONFIG
    // },
    DatePipe,
    MySocketWrapper,
    SocketService

  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
